module.exports = __webpack_public_path__ + "img/rides.83fb4974.svg";